<template>
	<v-col class="transfer-serial">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Transfer Serial Registrasi</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<router-link to="/">
				<div class="d-flex">
					<v-icon small color="grey">mdi-home</v-icon>
					<div class="pl-2 grey--text">Dashboard</div>
				</div>
			</router-link>
			<div class="px-2">/</div>
			<div>Serial</div>
			<div class="px-2">/</div>
			<div>Transfer Serial Registrasi</div>
		</div>
		<div class="mt-5">
			<div v-if="!suksesTransfer">
				<v-row class="ml-0">
					<v-col cols="12" sm="6" md="6" xl="4" class="pl-0">
						<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
							<v-row>
								<v-col cols="12" class="px-5 pt-5">
									<div class="font-size-14 cl-primary">Input Kode Mitra</div>
									<div class="pt-3">
										<v-autocomplete label="Pilih Mitra" no-data-text="Tidak ada data" color="primary" v-model="chosenMember" :items="dataDownline" item-text="name_code" item-value="name_code" return-object @change="enableProses"></v-autocomplete>
									</div>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
					<div v-if="listSerialAvaMember.length > 0">
						<v-row class="pt-3 ml-0">
							<v-col cols="12" sm="6" md="4" xl="3" class="pl-0 pt-0" v-for="(serial, i) in listSerialAvaMember" :key="i">
								<v-card class="pa-3 elevation-0 rounded-lg hover-shadow" @click="checkSerial(serial.serial_member_stock_serial_id)">
									<v-row>
										<v-col cols="2" sm="2" md="2" class="my-auto">
											<v-checkbox on-icon="mdi-check-circle" off-icon="mdi-checkbox-blank-circle-outline" class="mt-0" hide-details v-model="selectedSerial" :value="serial.serial_member_stock_serial_id" @click="checkSerial(serial.serial_member_stock_serial_id)"></v-checkbox>
										</v-col>
										<v-col cols="10" sm="10" md="10">
											<v-row>
												<v-col cols="12" md="12" class="pl-0 pb-0">
													<div class="font-size-10 cl-grey">Serial</div>
													<div class="font-size-13 font-size-xs-11 cl-primary font-weight-500">{{ serial.serial_member_stock_serial_id }}</div>
												</v-col>
												<v-col md="6" class="pl-0">
													<div class="font-size-10 cl-grey">Pembelian</div>
													<div class="font-size-10 cl-grey font-weight-500">{{ serial.serial_member_stock_datetime | tanggal }}</div>
												</v-col>
												<v-col md="6" class="pl-0">
													<div class="font-size-10 cl-grey">Kedaluwarsa</div>
													<div class="font-size-10 red--text text--lighten-2 font-weight-500">{{ serial.serial_member_stock_expired_date | tanggal }}</div>
												</v-col>
											</v-row>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
						</v-row>
						<div class="my-3">
							<v-row justify="center">
								<v-col cols="9" sm="4" md="3" xl="2">
									<v-btn block large outlined class="bg-white rounded-lg" color="primary" :loading="btnLoadingProses" :disabled="btnLoadingProses" v-if="serialAvaMemberPagination.total_page > 1 && serialAvaMemberPagination.next > 0" @click="loadMore">
										<v-icon>mdi-sync-circle</v-icon>
										<span class="pl-2">Muat Lebih Banyak</span>
									</v-btn>
								</v-col>
								<v-col cols="9" sm="3" md="2" xl="1" class="pt-0 pt-sm-3 pl-sm-0">
									<v-btn block large depressed class="bg-primary white--text rounded-lg" :loading="btnLoadingProses" :disabled="btnProses" @click="prosesTransfer">
										<v-icon>mdi-arrow-right-bold-circle</v-icon>
										<span class="pl-2">Proses</span>
									</v-btn>
								</v-col>
							</v-row>
						</div>
					</div>
				</v-scroll-x-reverse-transition>
				<div v-if="listSerialAvaMember.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data serial yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
			</div>
			<div v-if="suksesTransfer">
				<v-row>
					<v-col cols="12">
						<v-card class="py-3 elevation-0 bg-transparent rounded-lg">
							<v-img eager class="mx-auto" width="450" height="auto" src="/assets/icon/transfer-serial-success.svg"></v-img>
							<div class="pt-4 text-center cl-secondary">Selamat Anda Berhasil Mentransfer {{ responSuksesTransfer.length | toNumber }} Serial Kepada {{ memberTransfered }}</div>
						</v-card>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="mt-3 mt-sm-0">
						<div class="text-center">
							<v-btn large depressed class="bg-primary white--text rounded-lg" :loading="btnLoadingBack" :disabled="btnLoadingBack" @click="backInput">
								<span class="pl-2">Transfer Serial Kembali</span>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			page: 1,
			limit: '12',
			selectedSerial: [],
			chosenMember: '',
			dataDownline: [],
			btnLoadingProses: false,
			btnProses: true,
			btnLoadingBack: false,
			suksesTransfer: false,
			memberTransfered: '',
		}
	},
	computed: {
		...mapState('option', ['optionDownline']),
		...mapState('serial', ['listSerialAvaMember', 'serialAvaMemberPagination']),
		...mapState('transferSerial', ['responSuksesTransfer']),
	},
	methods: {
		...mapActions('option', ['getOptionDownline']),
		...mapActions('serial', ['getSerialAvaMember', 'getLoadSerialAvaMember']),
		...mapActions('transferSerial', ['transferMembership']),

		checkSerial(id) {
			if (this.selectedSerial.indexOf(id) > -1)
				this.selectedSerial = this.selectedSerial.filter(item => item !== id)
			else
				this.selectedSerial.push(id)
			this.enableProses()
		},
		downlineOption() {
			this.getOptionDownline().then(() => {
				this.dataDownline = this.optionDownline.map((el) => {
					return {
						network_id: el.network_id,
						network_code: el.network_code,
						member_name: el.member_name,
						name_code: el.network_code + ' - ' + el.member_name,
					}
				})
			})
		},
		loadMore() {
			this.btnLoadingProses = true
			this.page += 1
			this.getLoadSerialAvaMember(this.queryString({limit:this.limit, page: this.page})).then(() => {
				this.btnLoadingProses = false
			})
		},
		enableProses() {
			if (this.chosenMember && this.selectedSerial.length > 0)
				this.btnProses = false
			else
				this.btnProses = true
		},
		getData() {
			return new Promise(async (resolve) => {
				await this.getSerialAvaMember({serial_type: 'sys', limit:this.limit, page: this.page, sort: 'serial_member_serial_is_used', dir: 'asc'})
				await resolve()
			})
		},
		prosesTransfer() {
			this.btnLoadingProses = true
			this.btnProses = true
			let code = this.chosenMember.network_code
			let id = this.chosenMember.network_id
			let member = this.chosenMember.name_code
			let mapSerial = this.selectedSerial.map((el) => {
				return {
					serial_id: el
				}
			})
			this.transferMembership({network_code: code, network_id: id, arr_serial: mapSerial, network_type: 'bin'}).then(() => {
				this.btnLoadingProses = false
				this.btnProses = false
				this.suksesTransfer = true
				this.chosenMember = ''
				this.memberTransfered = member
			}).catch(() => {
				this.btnLoadingProses = false
			})
		},
		backInput() {
			this.btnLoadingBack = true
			this.getData().then(() => {
				this.btnLoadingBack = false
				this.suksesTransfer = false
			})
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Transfer Serial Registrasi`)
		this.downlineOption()
		this.getData()
	}
};
</script>

